import React from 'react';
import '@/App.css';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import ManpowerRequestPage from './pages/ManpowerRequestPage';
import RecruitmentCasesPage from './pages/RecruitmentCasesPage';
import CandidatePoolPage from './pages/CandidatePoolPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body-tertiary">
        <div className="text-body-secondary small">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppLayout({ children }) {
  return (
    <div>
      <Sidebar />
      <div className="wrapper d-flex flex-column min-vh-100" style={{ marginLeft: '220px' }}>
        <div className="body flex-grow-1 p-4 bg-body-tertiary">
          {children}
        </div>
      </div>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><AppLayout><DashboardPage /></AppLayout></ProtectedRoute>} />
      <Route path="/projects" element={<ProtectedRoute><AppLayout><ProjectsPage /></AppLayout></ProtectedRoute>} />
      <Route path="/projects/:projectId" element={<ProtectedRoute><AppLayout><ProjectDetailPage /></AppLayout></ProtectedRoute>} />
      <Route path="/manpower-request" element={<ProtectedRoute><AppLayout><ManpowerRequestPage /></AppLayout></ProtectedRoute>} />
      <Route path="/recruitment-cases" element={<ProtectedRoute><AppLayout><RecruitmentCasesPage /></AppLayout></ProtectedRoute>} />
      <Route path="/candidate-pool" element={<ProtectedRoute><AppLayout><CandidatePoolPage /></AppLayout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </HashRouter>
  );
}

export default App;
